var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRbackProvisions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6522 6.18649C17.5892 6.18649 14.5464 5.62753 12.193 4.05849C12.1359 4.02035 12.0687 4 12 4C11.9313 4 11.8641 4.02035 11.8069 4.05849C9.45356 5.62753 6.41078 6.18649 4.34783 6.18649C4.25558 6.18649 4.16711 6.22313 4.10188 6.28836C4.03665 6.35359 4 6.44206 4 6.53431C4 12.8387 6.93948 17.862 11.8629 19.9719C11.9063 19.9904 11.9529 20 12 20C12.0471 20 12.0937 19.9904 12.137 19.9719C17.0605 17.862 20 12.8387 20 6.53431C20 6.44206 19.9633 6.35359 19.8981 6.28836C19.8329 6.22313 19.7444 6.18649 19.6522 6.18649ZM11.6522 4.97396V11.6522H5.45322C4.97355 10.105 4.71945 8.49667 4.69878 6.87692C7.13538 6.80764 9.51985 6.15508 11.6522 4.97396ZM12.3478 19.103V12.3479H18.3068C17.28 15.2917 15.1409 17.7162 12.3478 19.1016V19.103Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbackProvisions);
export default __webpack_public_path__ + "static/media/rback-provisions.8335cf730599bdbda002fb4769e1efdb.svg";
export { ForwardRef as ReactComponent };